import { render } from "./WebhookDeliveriesTab.vue?vue&type=template&id=154640f3&scoped=true"
import script from "./WebhookDeliveriesTab.vue?vue&type=script&lang=js"
export * from "./WebhookDeliveriesTab.vue?vue&type=script&lang=js"

import "./WebhookDeliveriesTab.vue?vue&type=style&index=0&id=154640f3&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154640f3"]])

export default __exports__